<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import ZinputExpander from './zinput-expander.svelte'

    export let value: any[] = []
    export let options: { value: any; label: string; group?: string; disabled?: boolean }[] = []
    export let disabled = false
    export let labeled = false
    export let label = ''
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    $: safeValue = Array.isArray(value) ? value : []
    $: selectedOptions = safeValue.map((v) => options.find((o) => o.value === v)).filter(Boolean)
    $: availableOptions = options.filter((o) => !safeValue.includes(o.value))

    function addOption(opt, close?: () => void) {
        if (disabled || opt.disabled) return
        const wasLast = availableOptions.length === 1
        value = [...safeValue, opt.value]
        dispatch('change')
        if (wasLast) close?.()
    }

    function removeOption(v) {
        if (disabled) return
        value = safeValue.filter((el) => el !== v)
        dispatch('change')
    }

    function onOptionKeydown(ev, opt, close?: () => void) {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault()
            addOption(opt, close)
        }
    }

    function onChipClick(ev, v) {
        ev.stopPropagation()
        removeOption(v)
    }

    function onChipKeydown(ev, v) {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault()
            ev.stopPropagation()
            removeOption(v)
        }
    }
</script>

<ZinputExpander titulo={label} {disabled} {labeled} bind:htmlInput>
    <svelte:fragment slot="trigger">
        {#if selectedOptions.length > 0}
            <div class="multiselect_chips">
                {#each selectedOptions as opt (opt.value)}
                    <span
                        class="multiselect_chip"
                        role="button"
                        tabindex="0"
                        title="Remover"
                        on:click={(ev) => onChipClick(ev, opt.value)}
                        on:keydown={(ev) => onChipKeydown(ev, opt.value)}
                    >
                        {opt.label}
                        <span class="multiselect_chip-remove">×</span>
                    </span>
                {/each}
            </div>
        {/if}
    </svelte:fragment>
    <svelte:fragment slot="panel" let:close>
        {#if availableOptions.length === 0}
            <div class="multiselect_empty">Nenhuma opção disponível</div>
        {/if}
        {#each availableOptions as opt (opt.value)}
            <div
                class="multiselect_option"
                class:disabled={opt.disabled}
                role="button"
                tabindex="0"
                on:click={() => addOption(opt, close)}
                on:keydown={(ev) => onOptionKeydown(ev, opt, close)}
            >
                {opt.label}
            </div>
        {/each}
    </svelte:fragment>
</ZinputExpander>

<style>
    .multiselect_chips {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        padding: 0px 0px 0px 6px;
        min-width: 0;
    }

    .multiselect_chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: var(--bs-primary);
        border-radius: 6px;
        padding: 1px 6px;
        font-size: 13px;
        cursor: pointer;
    }

    .multiselect_chip:hover {
        opacity: 0.85;
    }

    :global(.theme_light) .multiselect_chip {
        color: #fff;
    }

    .multiselect_chip-remove {
        cursor: pointer;
        opacity: 0.6;
        font-weight: bold;
        line-height: 1;
    }

    .multiselect_chip-remove:hover {
        opacity: 1;
    }

    /* a linha segue a altura das opções do select (Zoption): lista apertada parece lista
       desligada, e no toque a linha baixa erra o alvo */
    .multiselect_option {
        display: flex;
        align-items: center;
        min-height: 42px;
        padding: 10px 12px;
        font-size: 15px;
        line-height: 1.3;
        cursor: pointer;
    }

    @media (pointer: coarse) {
        .multiselect_option {
            min-height: 56px;
            padding: 12px 14px;
            font-size: 16px;
        }
    }

    .multiselect_option:hover {
        background-color: #ffffff12;
    }

    :global(.theme_light) .multiselect_option:hover {
        background-color: #00000010;
    }

    .multiselect_option.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .multiselect_empty {
        padding: 6px 12px;
        opacity: 0.6;
        font-size: 13px;
    }
</style>
